// Narrows the frame-by-frame view to one kind of note, e.g. only the frames
// with issues. Each chip shows how many frames it keeps; a chip that keeps
// none is disabled. The coloured chips double as the legend.
import React from 'react';
import { C, ToneMark } from './ui';

const plural = (n, unit) => `${n} ${unit}${n === 1 ? '' : 's'}`;

export default function FrameFilter({ options, value, unit, onChange }) {
    return (
        <div role="group" aria-label="Show frames" style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            {options.map((o) => {
                const on = o.id === value;
                const tone = o.tones?.length === 1 ? o.tones[0] : null;
                return (
                    <button key={o.id} type="button" className="vqc-chip" aria-pressed={on} disabled={!on && !o.count}
                        aria-label={`${o.label}, ${plural(o.count, unit)}`} onClick={() => onChange(o.id)}
                        style={{
                            display: 'inline-flex', alignItems: 'center', gap: 6, boxSizing: 'border-box', minHeight: 32, padding: '0 12px', borderRadius: 999, fontFamily: 'inherit',
                            fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap', cursor: !on && !o.count ? 'not-allowed' : 'pointer',
                            opacity: !on && !o.count ? 0.45 : 1,
                            background: on ? C.navy : '#fff', color: on ? '#fff' : C.text, border: `1px solid ${on ? C.navy : C.border}`,
                        }}>
                        {tone && <ToneMark tone={tone} flag={tone === 'flag'} size={8} />}
                        {o.label}
                        <span aria-hidden="true" style={{ fontVariantNumeric: 'tabular-nums', color: on ? 'rgba(255,255,255,0.72)' : C.muted }}>{o.count}</span>
                    </button>
                );
            })}
        </div>
    );
}
